export default __webpack_public_path__ + "media/images/ui-icons_222222_256x240-1c44ba041af75dc0660cfb33adc91a37.png";